'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ContextComponent = require('../../../global/components/ContextComponent');
const SanitizeHtml = require('../../../global/components/SanitizeHtml');
const {trackAttributeClick} = require('../../actions/pdpTrackingActions');

class DetailsItem extends ContextComponent {
    constructor(props) {
        super(props);
        this.fireTracking = this.fireTracking.bind(this);
    }

    fireTracking() {
        const label = this.props.gaLabel;
        this.context.executeAction(trackAttributeClick, {label});
    }

    /**
     * Renders markup for each object in the prop contents,
     * an array structured like so
     * {{
     *     value: string,
     *     isLink: boolean,
     *     link: string,
     *     extraCopy: string
     * }[]}
     */
    render() {
        const contentsLength = this.props.contents.length - 1;

        let detailItems = this.props.contents.map((content, index) => {
            let extraCopy = content.extraCopy ? ' ' + content.extraCopy : '';
            let delimiter = index < contentsLength ? ', ' : '';

            if (content.isLink && content.link && !this.props.isPrintPage) {
                return (
                    <div className="pdp-details-entry-content" key={index}>
                        <a className="pdp-details-entry-content-link" href={content.link} onClick={this.fireTracking}>
                            <SanitizeHtml content={content.value} />
                        </a>
                        {extraCopy}
                        {delimiter}
                    </div>
                );
            } else {
                return (
                    <div className="pdp-details-entry-content" key={index}>
                        <SanitizeHtml content={content.value} />
                        {extraCopy}
                        {delimiter}
                    </div>
                );
            }
        });

        return (
            <li className="pdp-details-entry">
                <div className="pdp-details-entry-title-container">
                    <span className="pdp-details-entry-title">{this.props.title}</span>
                </div>
                <div className="pdp-details-entry-content-container" data-tn={this.props.testName}>
                {detailItems}
                </div>
            </li>
        );
    }
}

DetailsItem.defaultProps = {
    isPrintPage: false
};


DetailsItem.propTypes = {
    contents: PropTypes.array.isRequired,
    gaLabel: PropTypes.string,
    testName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isPrintPage: PropTypes.bool
};

module.exports = DetailsItem;



// WEBPACK FOOTER //
// ./assets/js/newPdp/details/components/DetailsItem.jsx